export default {
  title: "اللغات النشطة في إكسكوينو",
  farsi: "الفارسية",
  english: "English",
  arabic: "العربية",
  confirmBtn: "تأكيد"
};
